export function findQueryKeyNoCaseSensitive(queryKey :string) : string | null{
    var urlParams = new URLSearchParams(window.location.search);
    var queryValue = null;
    for (const [key, value] of Array.from(urlParams.entries())) {
      if (key.toLowerCase() === queryKey.toLowerCase()) {
        queryValue = value;
        break;
      }
    }
    return queryValue
  }

import { api } from "@portal/arq-portal-core";

export async function postGD(url: string, input: FormData) {
    try {
      const request = new Request(api.getApiServer() + url, {
        method: 'POST',
        mode: 'cors',
        credentials: "include",
        body: input,
      });
  
      const response = await window.fetch(request);
  
      if (response.ok) {
        const json = await response.json();
        return json || null;
      } else {
        throw new Error(response.statusText);
      }
    } catch (e) {
      console.warn("post_error", e);
      throw e;
    }
}
